module.exports = __webpack_public_path__ + "8c88bf8df025c391b7894b387a32167c.svg";